var e = {
  labelWrapper: "checkbox__label-wrapper",
  label: "checkbox__label"
},
    c = {
  classNames: e
};
export { c as checkboxSelectors };